import React, {useEffect, useState} from 'react';
import {Card, Col, message, Row, Statistic} from 'antd';
import {getDashboardStats} from "../api/dashboard";
import {useAppDispatch} from "../hooks";
import {setAmount} from "../features/counter/counterSlice";

const Dashboard: React.FC = () => {

    const [userCount, setUserCount] = useState(0);
    const [applicationCount, setApplicationCount] = useState(0);
    const [notificationCount, setNotificationCount] = useState(0);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const fetchData = () => {
            getDashboardStats()
                .then((data) => {
                    setUserCount(data.usersCount);
                    setApplicationCount(data.applicationsCount);
                    setNotificationCount(data.userMsgCount);
                    dispatch(setAmount(data.userMsgCount));
                })
                .catch((error) => {
                    console.error('Error fetching dashboard data:', error);
                    void message.error(`Erreur lors du chargement des données du tableau de bord ${error.message}`);
                });
        }

        fetchData();
        const interval = setInterval(fetchData, 60000); // toutes les 60 secondes
        return () => clearInterval(interval);

    }, [dispatch]);


    return (
        <div style={{padding: '1rem'}}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                    <Card>
                        <Statistic title="Utilisateurs inscrits" value={userCount} suffix="👤"/>
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Card>
                        <Statistic title="Applications actives" value={applicationCount} suffix="📂"/>
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Card>
                        <Statistic title="Notifications" value={notificationCount} suffix="🔔"/>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Dashboard;
